export const environment = {
  production: true,
  sentry: {
    dsn: process.env.NX_SENTRY_DSN || '',
    environment: process.env.NX_SENTRY_ENVIRONMENT || 'production',
  },
};
